import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PrintingVariableInfo  {
    _originalTypeClassName = "zERP.BO.PrintingVariableInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PrintingVariableInfo.translate = translateService;
}
this.Value = null;
this.Description = null;
this.TypesAndArgs = null;
this.PrintingVariableInfoKey = null;
this._key = this.PrintingVariableInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
Value:any;
Description:any;
TypesAndArgs:any;
private _PrintingVariableInfoKey:any;
get PrintingVariableInfoKey(): any {
    return this._PrintingVariableInfoKey;
  }
set PrintingVariableInfoKey(value: any) {
    this._PrintingVariableInfoKey = value;
    this._key = value;
  }

static CreateVariable(value: any,description: any,argsTypes: any): any{let variable = new Domain.PrintingVariableInfo();
variable.Value = value;
variable.Description = description;
if ((!(CLMS.Framework.String.IsNullOrEmpty(argsTypes)))) {variable.TypesAndArgs = argsTypes;}
return variable;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PrintingVariableInfoKey == null || $this.PrintingVariableInfoKey == 0;
            }


}